var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"lazy-animate",rawName:"v-lazy-animate"}],staticClass:"standard-service-wrap"},[_c('LineWrap',{attrs:{"titleObj":_vm.titleObj}}),_c('Tab')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }